<template>
    <div>
        <el-upload
            ref="upload"
            :class="{disabled:disabled}"
            :action="FILE_UPLOAD_HOST"
            :data="QNData"
            name="file"
            :accept="accept"
            :multiple="multiple"
            :http-request="uploadBigFile"
            :show-file-list="false"
            :on-error="uploadError"
            :on-success="uploadSuccess"
            :before-upload="beforeAvatarUpload" :disabled="disabled" v-if="!folder">
            <template v-if="!disabled">
                <slot name="upload"></slot>
            </template>
        </el-upload>
        <input ref="file" class="fileUploaderClass cursor" type='file' name="file"
               webkitdirectory style="position: absolute;left: 0;top: 0;width:100%;height:100%;opacity: 0;"
               @change="uploadFiles($event)" v-else/>
        <upload-file-loading :dialog-visible="loading" :files="files" :auto="auto" @watchState="watchState" @startUpFile="startUpFile" @stopUpFile="stopUpFile"></upload-file-loading>
    </div>
</template>

<script>
import {FILE_PATH, FILE_UPLOAD_HOST} from "@/config";
import {getQNFileKey, getQNFileName, getQNFilesKey, toast, TOAST} from "@/utils/utils";
import {getQNToken} from "@/utils/CryptoJS";
import * as qiniu from 'qiniu-js'
import UploadFileLoading from "./UploadFileLoading";
import {addNoticeFile, addPostOutcomeFile, addProjectFolder} from "@/api";

export default {
    name: "UploadFile",
    components: {UploadFileLoading},
    data() {
        return {
            FILE_PATH: FILE_PATH,
            FILE_UPLOAD_HOST: FILE_UPLOAD_HOST,
            QNData: {
                fname: '', //  文件名
                key: '', //文件名字处理
                token: getQNToken() //七牛云token
            },
            config: {
                // config.useCdnDomain: 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
                // config.disableStatisticsReport: 是否禁用日志报告，为布尔值，默认为 false。
                // config.uphost: 上传 host，类型为 string[] | string，如果指定一个非空数组或者非空字符串，则仅使用该数据作为上传 host，默认为 []，传入多个 host 时，内部会在重试过程中根据情况自动切换不同的 host。
                // config.upprotocol: 自定义上传域名协议，值为 https 或者 http，默认为 https。
                // config.region: 选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域，当指定了 uphost 时，此设置项无效。
                // config.retryCount: 上传自动重试次数（整体重试次数，而不是某个分片的重试次数）；默认 3 次（即上传失败后最多重试两次）。
                // config.concurrentRequestLimit: 分片上传的并发请求量，number，默认为3；因为浏览器本身也会限制最大并发量，所以最大并发量与浏览器有关。
                // config.checkByServer: 是否开启服务端文件签名校验，为布尔值；开启后在文件上传时会计算本地的文件签名，服务端会根据本地的签名与接收到的数据的签名进行比对，如果不相同、则说明文件可能存在问题，此时会返回错误（code: 406），默认为 false，不开启。
                // config.checkByMD5: 是否开启 MD5 校验，为布尔值；在断点续传时，开启 MD5 校验会将已上传的分片与当前分片进行 MD5 值比对，若不一致，则重传该分片，避免使用错误的分片。读取分片内容并计算 MD5 需要花费一定的时间，因此会稍微增加断点续传时的耗时，默认为 false，不开启。
                // config.forceDirect: 是否上传全部采用直传方式，为布尔值；为 true 时则上传方式全部为直传 form 方式，禁用断点续传，默认 false。
                // config.chunkSize: number，分片上传时每片的大小，必须为正整数，单位为 MB，且最大不能超过 1024，默认值 4。因为 chunk 数最大 10000，所以如果文件以你所设的 chunkSize 进行分片并且 chunk 数超过 10000，我们会把你所设的 chunkSize 扩大二倍，如果仍不符合则继续扩大，直到符合条件。
                // config.debugLogLevel: INFO | WARN | ERROR | OFF，允许程序在控制台输出日志，默认为 OFF，不输出任何日志，本功能仅仅用于本地调试，不建议在线上环境开启。
                concurrentRequestLimit: 9,
                checkByMD5: true,
                useCdnDomain: true,
                region: qiniu.region.z1
            },
            files: [],
            new_wid: '',
            loading: false
        }
    },
    props: {
        name: { // 多个上传时 用来区分
            type: String,
            default: ''
        },
        params: { // 上传成功后请求接口的参数，
            type: [String, Object],
            default: ''
        },
        disabled: { // 是否可用
            type: Boolean,
            default: false
        },
        multiple: { //多文件上传
            type: Boolean,
            default: false
        },
        folder: { // 上传文件夹 初始化是定义 不可修改
            type: Boolean,
            default: false
        },
        auto: { // 是否自动上传
            type: Boolean,
            default: true
        },
        accept: { // 文件类型
            type: String,
            default: ''
        },
        size: { //文件大小
            type: Number,
            default: 100
        }
    },
    computed: {
        token() {
            return this.$store.state.token;
        },
        fileData() {
            return {
                mid: this.token,
            }
        }
    },
    created() {

    },
    methods: {
        //  上传钱判断
        beforeAvatarUpload() {
        },
        //  上传成功
        uploadSuccess(res, file) {
            this.$emit('uploadFile', {
                name: this.name,
                file: {
                    name: file.name,
                    url: `${this.FILE_PATH}/${res.key}`
                }
            })
        },
        //  上传失败
        uploadError() {

        },
        async uploadFiles(files) {
            let cur_did = this.params.did
            let cur_parent_did = this.params.pdid
            this.new_wid = ''
            let _data = this.name === 'notice' ?   await addNoticeFile(this.params.pid, cur_parent_did, 1, '', files.target.files[0].webkitRelativePath.split('/')[0], cur_did)
                : this.name === 'cutcome' ? await addPostOutcomeFile(this.params.pid, cur_parent_did, 1, '', files.target.files[0].webkitRelativePath.split('/')[0], cur_did)
                :  await addProjectFolder(this.params.pid, cur_did, cur_parent_did, files.target.files[0].webkitRelativePath.split('/')[0])
            if (_data.status === 200) {
                this.new_wid = this.name ?  _data.data.id :  _data.data
                // let _count = files.target.files.length
                let _this = this
                Array.from(files.target.files).map(async (file) => {
                    console.log(file)
                    const isEmpty = file.size === 0
                    if (isEmpty) {
                        toast('上传文件为空', TOAST.error)
                    } else {
                        const isLt2M = file.size / 1024 / 1024 < _this.size;
                        if (!isLt2M) {
                            return toast(`上传文件大小不能超过 ${_this.size}MB!`, TOAST.error)
                        }
                        _this.QNData.fname = getQNFileName(file.name)
                        _this.QNData.key = getQNFilesKey(file.webkitRelativePath)
                        const observable = qiniu.upload(file, _this.QNData.key, _this.QNData.token, {
                            fname: _this.QNData.fname,
                        }, _this.config)
                        _this.files.push({
                            uid: _this.QNData.key,
                            name: file.name,
                            file: file,
                            size: file.size,
                            progress: '',
                            subscription: '',
                            observable: observable,
                            error: '',
                            status: 0,  //0 未开始 1 进行中 -1 上传失败 // 2上传成功
                        })
                        let findIndex = _this.files.length - 1
                        if (_this.auto) {
                            _this.startFileUp(findIndex)
                        } else {
                            _this.loading = true
                        }
                    }
                })
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        uploadBigFile(options) {
            let _this = this
            _this.file_size = options.file.size
            const isLt2M = _this.file_size / 1024 / 1024 < _this.size;
            if (!isLt2M) {
                return toast(`上传文件大小不能超过 ${_this.size}MB!`, TOAST.error)
            }
            let findIndex = _this.files.findIndex(f => {
                return f.uid === options.file.uid
            })
            if (findIndex === -1) {
                _this.QNData.fname = getQNFileName(options.file.name)
                _this.QNData.key = getQNFileKey(options.file.name)
                const observable = qiniu.upload(options.file, _this.QNData.key, _this.QNData.token, {
                    fname: _this.QNData.fname,
                }, _this.config)
                _this.files.push({
                    uid: options.file.uid,
                    name: options.file.name,
                    file: options.file,
                    size: _this.file_size,
                    progress: '',
                    subscription: '',
                    observable: observable,
                    error: '',
                    status: 0,  //0 未开始 1 进行中 -1 上传失败 // 2上传成功
                })
                findIndex = _this.files.length - 1
            }
            if (_this.auto) {
                _this.startFileUp(findIndex)
            } else {
                _this.loading = true
            }
        },
        startUpFile(data) {
            console.log(data)
            if (data.index === -1) {
                this.files.map((item, index) => {
                    console.log(item)
                    this.startFileUp(index)
                })
            } else {
                this.startFileUp(data.index)
            }
        },
        stopUpFile(data) {
            console.log(data)
            if (data.index === -1) {
                this.files.map(f => {
                    f.status = 0
                    f.subscription.unsubscribe() // 上传取消
                })
            } else {
                this.files[data.index].status = 0
                this.files[data.index].subscription.unsubscribe() // 上传取消
            }
        },
        startFileUp(findIndex) {
            let _this = this
            _this.files[findIndex].subscription = _this.files[findIndex].observable.subscribe({
                next(res) {
                    console.log('ing', res)
                    _this.files[findIndex].status = res.total.percent === 100 ? 2 : 1
                    _this.files[findIndex].progress = res
                    if (!_this.loading) _this.loading = true
                },
                error(err) {
                    console.log('err', err)
                    _this.files[findIndex].error = err
                    _this.files[findIndex].status = -1
                },
                complete(res) {
                    console.log('ed', res)
                    _this.$emit('uploadFile', {
                        name: _this.name,
                        params: {..._this.params, new_wid: _this.new_wid},
                        file: {
                            file: _this.files[findIndex].file,
                            name: _this.files[findIndex].name,
                            url: `${_this.FILE_PATH}/${res.key}`
                        }
                    })
                    _this.files[findIndex].status = 2
                }
            }) // 上传开始

        },
        watchState() {
            this.loading = false
            this.files.map(f => {
                f.subscription.unsubscribe() // 上传取消
            })
            this.files.length = 0
        }
    },
    watch: {}
}
</script>

<style>
.el-upload {
    display: flex
}
</style>